// Chitta secondary graphic translated to digital: fine blue line forms
// with the light-blue square accent, placed bottom-left, used as accent only.
export const ChittaGraphic = ({ className = "", light = false }) => (
    <svg
        viewBox="0 0 220 120"
        fill="none"
        aria-hidden="true"
        className={className}
    >
        <line x1="0" y1="119.5" x2="220" y2="119.5" stroke={light ? "#2bcaef" : "#073077"} strokeOpacity="0.55" />
        <line x1="24" y1="120" x2="24" y2="64" stroke={light ? "#2bcaef" : "#073077"} strokeOpacity="0.4" />
        <line x1="48" y1="120" x2="48" y2="34" stroke={light ? "#2bcaef" : "#073077"} strokeOpacity="0.4" />
        <line x1="72" y1="120" x2="72" y2="78" stroke={light ? "#2bcaef" : "#073077"} strokeOpacity="0.4" />
        <line x1="96" y1="120" x2="96" y2="12" stroke={light ? "#2bcaef" : "#073077"} strokeOpacity="0.4" />
        <line x1="120" y1="120" x2="120" y2="52" stroke={light ? "#2bcaef" : "#073077"} strokeOpacity="0.4" />
        <line x1="144" y1="120" x2="144" y2="88" stroke={light ? "#2bcaef" : "#073077"} strokeOpacity="0.4" />
        <rect x="90" y="0" width="12" height="12" fill="#2bcaef" />
    </svg>
);
